/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { c as createSVGComponent } from '../utils-9450cd75.js';
import '@carbon/icon-helpers';
import 'vue';

const ChevronUp16 = createSVGComponent('ChevronUp16', {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 16 16",
  "fill": "currentColor",
  "width": 16,
  "height": 16
}, [{
  "elem": "path",
  "attrs": {
    "d": "M8 5L13 10 12.3 10.7 8 6.4 3.7 10.7 3 10z"
  }
}]);

export { ChevronUp16 as default };
